import { Content, List, Root as Tabs, Trigger } from '@radix-ui/react-tabs';
import { IppicaNavTabAntePost, IppicaNavTabToday } from './ippicaNavTabs';
import { initialState, setActiveTab } from 'features/ippica/ippicaSlice';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { IppicaNavHeader } from './ippicaNavHeader/IppicaNavHeader';
import { IppicaNazioneDto } from 'types/swagger';
import { POLLING_INTERVAL_IPPICA } from 'features/ippica/constants';
import React, { useEffect } from 'react';
import { TabValue } from 'features/ippica/types';
import { selectActiveTab } from 'features/ippica/selectors';
import styles from './IppicaNav.module.scss';
import { useLazyGetIppicaMenuQuery } from 'features/api/ippicaApiSlice';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useRouter } from 'next/router';

export type IppicaNavProps = {
  mieiIppodromi?: Array<IppicaNazioneDto>;
};

export const IppicaNav = ({ mieiIppodromi }: IppicaNavProps) => {
  const dispatch = useAppDispatch();
  const { isReady, asPath } = useRouter();
  const labelStato = useGetLabelByKey('stato-corse');
  const labelAntepost = useGetLabelByKey('antepost');

  const activeTab = useTypedSelector(selectActiveTab);

  const [getIppicaMenu] = useLazyGetIppicaMenuQuery({
    pollingInterval: POLLING_INTERVAL_IPPICA,
  });

  const handleTabChange = (value: TabValue) => {
    dispatch(setActiveTab(value));
  };

  useEffect(() => {
    if (isReady) {
      getIppicaMenu(activeTab);
    }
  }, [activeTab, asPath, getIppicaMenu, isReady]);

  return (
    <React.Fragment key={`IppicaNav-${activeTab}`}>
      <IppicaNavHeader label={'Corse'} />
      <div className={styles.container}>
        <Tabs
          value={activeTab}
          className={styles.root}
          defaultValue={initialState.activeTab}
          onValueChange={handleTabChange}
        >
          <List>
            <Trigger value={TabValue.TODAY} className={styles.tab}>
              {labelStato}
            </Trigger>
            <Trigger value={TabValue.ANTEPOST} className={styles.tab}>
              {labelAntepost}
            </Trigger>
          </List>
          <Content value={TabValue.TODAY} className={styles.tabContent}>
            <IppicaNavTabToday mieiIppodromi={mieiIppodromi} key={`${TabValue.TODAY}-${activeTab}`} />
          </Content>
          <Content value={TabValue.ANTEPOST} className={styles.tabContent}>
            <IppicaNavTabAntePost key={`${TabValue.ANTEPOST}-${activeTab}`} />
          </Content>
        </Tabs>
      </div>
    </React.Fragment>
  );
};
